import {eTipoPermissao} from '@/enums/ePermissoes';
export default [
 {
  description: 'Tipo de Perdas',
  path: '/merenda/mertipoperda',
  name: 'mertipoperda',
  component: () => import('@/views/merenda/mertipoperda/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEPERDASNOVO_MENU_1900500699],
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Tipo de Perdas',
  path: '/merenda/mertipoperda/cadastro/:id?',
  parent: 'mertipoperda',
  name: 'mertipoperda_create',
  component: () => import('@/views/merenda/mertipoperda/InclusaoEdicao.vue'),
  meta: {
   permissions: [eTipoPermissao.TIPODEPERDASNOVO_MENU_1900500699],
  },
  goesToMenu: true,
 },
]
